import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface IWidthEntityAttributes extends IModelAttributes {
	label: string;
	isBase?: boolean;
	capacityMultiplier: number;
	pricingMultiplier: number;

	cargoWidths: Array<Models.CargoTypeEntity | Models.ICargoTypeEntityAttributes>;
	selectedCargoWidths: Array<Models.CargoEntity | Models.ICargoEntityAttributes>;
	// capacityTypes: Array<
	// 	| Models.CapacityTypeWidth
	// 	| Models.ICapacityTypeWidthAttributes
	// >;
}

@entity('WidthEntity', 'Width')
export default class WidthEntity extends Model implements IWidthEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<WidthEntity, string>()
	public label: string;

	@observable
	@attribute<WidthEntity, string>()
	public isBase?: boolean;

	@observable
	@attribute<WidthEntity, number>()
	public capacityMultiplier: number;

	@observable
	@attribute<WidthEntity, number>()
	public pricingMultiplier: number;

	@observable
	@attribute({ isReference: true, manyReference: true })
	public cargoWidths: Models.CargoTypeEntity[] = [];

	@observable
	@attribute({ isReference: true, manyReference: true })
	public selectedCargoWidths: Models.CargoEntity[] = [];

	// @observable
	// @attribute({ isReference: true, manyReference: true })
	// @CRUD({
	// 	name: 'Capacity types',
	// 	description: 'The capacity types for the measurement.',
	// 	displayType: 'hidden',
	// 	order: 100,
	// 	referenceTypeFunc: () => Models.CapacityTypeWidth,
	// 	optionEqualFunc: (model, option) => model.id === option,
	// 	inputProps: {
	// 		fetchReferenceEntity: true,
	// 	},
	// 	referenceResolveFunction: makeFetchManyToManyFunc({
	// 		entityName: 'measurementEntity',
	// 		oppositeEntityName: 'capacityTypeEntity',
	// 		relationName: 'measurements',
	// 		relationOppositeName: 'capacityTypes',
	// 		entity: () => Models.WidthEntity,
	// 		joinEntity: () => Models.CapacityTypeWidth,
	// 		oppositeEntity: () => Models.CapacityTypeEntity,
	// 	}),
	// })
	// public capacityTypes: Models.CapacityTypeWidth[] = [];

	constructor(attributes?: Partial<IWidthEntityAttributes>) {
		super(attributes);

		this.cargoWidths = [];
		this.selectedCargoWidths = [];

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IWidthEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.label !== undefined) {
				this.label = attributes.label;
			}
			if (attributes.isBase !== undefined) {
				this.isBase = attributes.isBase;
			}
			if (attributes.capacityMultiplier !== undefined) {
				this.capacityMultiplier = attributes.capacityMultiplier;
			}
			if (attributes.pricingMultiplier !== undefined) {
				this.pricingMultiplier = attributes.pricingMultiplier;
			}
			if (attributes.cargoWidths !== undefined && Array.isArray(attributes.cargoWidths)) {
				if (!this.cargoWidths) {
					this.cargoWidths = [];
				}
				for (const model of attributes.cargoWidths) {
					if (model instanceof Models.CargoTypeEntity) {
						this.cargoWidths.push(model);
					} else {
						this.cargoWidths.push(new Models.CargoTypeEntity(model));
					}
				}
			}
			if (attributes.selectedCargoWidths !== undefined && Array.isArray(attributes.selectedCargoWidths)) {
				if (!this.selectedCargoWidths) {
					this.selectedCargoWidths = [];
				}
				for (const model of attributes.selectedCargoWidths) {
					if (model instanceof Models.CargoEntity) {
						this.selectedCargoWidths.push(model);
					} else {
						this.selectedCargoWidths.push(new Models.CargoEntity(model));
					}
				}
			}
			// if (isNotNullOrUndefined(attributes.capacityTypes)) {
			// 	for (const model of attributes.capacityTypes) {
			// 		if (model instanceof Models.CapacityTypeWidth) {
			// 			this.capacityTypes.push(model);
			// 		} else {
			// 			this.capacityTypes.push(new Models.CapacityTypeWidth(model));
			// 		}
			// 	}
			// }
		}
	}
}

export interface WidthDto {
	id: string;
	label: string;
	isBase: boolean;
	capacityMultiplier: number;
}
